export const SpotifyCard = ({ url, meta, postId }) => {
  const cleanUrl = url.split("?")[0].replace(/\/intl-[a-z]{2}\//, "/");
  const spotifyPath = cleanUrl.replace("https://open.spotify.com/", "");

  // Always use the iframe embed to keep users in-app
  return (
    <div className="mt-3 rounded-2xl overflow-hidden w-full max-w-full" data-testid={`spotify-card-${postId}`}>
      <iframe
        src={`https://open.spotify.com/embed/${spotifyPath}?utm_source=generator&theme=0`}
        width="100%"
        height="152"
        frameBorder="0"
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
        className="rounded-2xl"
        title="Spotify"
        style={{ maxWidth: "100%" }}
      />
    </div>
  );
};
